export const tickerItems: string[] = [
  '今日新增 32 个可播放高清站点',
  '《夜行手记》短片已更新至第 4 集',
  '站点「夜航影院」线路 3 播放速度已恢复正常',
  '本周榜单前三名变化：纪录片类整体挤进前二',
  '深夜档专区上新 12 部高分短片',
  '上线巡检完成：收录站点在线率 97.4%',
];

export const heroStats: { id: string; value: string; label: string }[] = [
  { id: 'sites', value: '486', label: '今日在库站点' },
  { id: 'updates', value: '32', label: '今日更新资源' },
  { id: 'online', value: '97.4%', label: '在线可播放率' },
  { id: 'picks', value: '12', label: '深夜档新上' },
];

export const ranking: {
  id: string;
  title: string;
  tag: string;
  desc: string;
  heat: number;
}[] = [
  { id: 'r1', title: '光影放映厅', tag: '综合', desc: '资源齐全，分类清晰，适合日常刷片', heat: 9860 },
  { id: 'r2', title: '夜航影院', tag: '高清', desc: '夜间线路稳定，更新频率高', heat: 9230 },
  { id: 'r3', title: '胶片仓库', tag: '经典', desc: '专注老片修复与冷门佳作', heat: 8810 },
  { id: 'r4', title: '白噪音片场', tag: '纪录片', desc: '沉浸式长片与自然影像', heat: 8420 },
  { id: 'r5', title: '午夜短片集', tag: '短片', desc: '每集 15 分钟，适合碎片时间', heat: 7900 },
  { id: 'r6', title: '城市漫游影像', tag: '旅行', desc: '城市与旅途记录，画质清爽', heat: 7450 },
  { id: 'r7', title: '静帧电影馆', tag: '文艺', desc: '慢节奏文艺片单，安静耐看', heat: 7100 },
  { id: 'r8', title: '星轨放映机', tag: '科幻', desc: '科幻短片与实验影像合集', heat: 6820 },
];

export const newsFeed: { id: string; time: string; title: string; note: string }[] = [
  { id: 'n1', time: '08:20', title: '线路更换', note: '站点「光影放映厅」线路 2 已更换，可正常播放' },
  { id: 'n2', time: '10:05', title: '片单上新', note: '新增《城市的十二个夜晚》共 12 段影像' },
  { id: 'n3', time: '12:40', title: '榜单更新', note: '纪录片类整体上升两位，进入前二' },
  { id: 'n4', time: '15:10', title: '画质修复', note: '站点「胶片仓库」老片清晰度完成提升' },
  { id: 'n5', time: '18:30', title: '深夜档上新', note: '深夜档专区新增 12 部高分短片' },
  { id: 'n6', time: '21:15', title: '巡检完成', note: '全部播放线路状态巡检完成，主线可用' },
];

export const siteNav: {
  id: string;
  name: string;
  tag: string;
  desc: string;
  status: 'online' | 'maintenance';
  updated: string;
}[] = [
  { id: 'g1', name: '光影放映厅', tag: '综合', desc: '资源齐全，分类清晰，适合日常刷片', status: 'online', updated: '2 分钟前' },
  { id: 'g2', name: '夜航影院', tag: '高清', desc: '夜间线路稳定，更新频率高', status: 'online', updated: '8 分钟前' },
  { id: 'g3', name: '胶片仓库', tag: '经典', desc: '专注老片修复与冷门佳作', status: 'online', updated: '15 分钟前' },
  { id: 'g4', name: '白噪音片场', tag: '纪录片', desc: '沉浸式长片与自然影像', status: 'online', updated: '22 分钟前' },
  { id: 'g5', name: '午夜短片集', tag: '短片', desc: '每集 15 分钟，适合碎片时间', status: 'online', updated: '30 分钟前' },
  { id: 'g6', name: '城市漫游影像', tag: '旅行', desc: '城市与旅途记录，画质清爽', status: 'maintenance', updated: '1 小时前' },
];

export const hotResources: {
  id: string;
  title: string;
  type: string;
  meta: string;
  heat: string;
  badge?: string;
}[] = [
  { id: 'h1', title: '夜行手记', type: '剧情', meta: '42 分钟 · 已更新至第 4 集', heat: '9.6', badge: '本周最热' },
  { id: 'h2', title: '城市的十二个夜晚', type: '纪录', meta: '6 段合集 · 每段约 12 分钟', heat: '9.2', badge: '编辑推荐' },
  { id: 'h3', title: '海边的信号塔', type: '剧情', meta: '28 分钟 · 单集', heat: '9.0' },
  { id: 'h4', title: '无人售票', type: '悬疑', meta: '35 分钟 · 单集', heat: '8.8' },
  { id: 'h5', title: '白昼之后', type: '文艺', meta: '51 分钟 · 单集', heat: '8.6' },
  { id: 'h6', title: '旧码头', type: '纪录', meta: '24 分钟 · 单集', heat: '8.3' },
];

export const nightPicks: { id: string; time: string; title: string; note: string }[] = [
  { id: 'p1', time: '01:30', title: '适合安静看完的 40 分钟短片', note: '细水长流的叙事，适合睡前慢慢看' },
  { id: 'p2', time: '02:00', title: '低亮度画面 · 助眠型纪录片', note: '自然影像与轻声解说，画面柔和不刺眼' },
  { id: 'p3', time: '03:15', title: '悬疑短片连播 · 全程高能', note: '一口气看完的短小精悍，节奏紧凑' },
  { id: 'p4', time: '04:00', title: '白噪音 + 城市夜景影像', note: '无对白，只有光影和雨声，放着就能睡' },
];

export const categories: { id: string; name: string; count: number }[] = [
  { id: 'c1', name: '剧情', count: 128 },
  { id: 'c2', name: '短片', count: 210 },
  { id: 'c3', name: '纪录', count: 96 },
  { id: 'c4', name: '文艺', count: 88 },
  { id: 'c5', name: '悬疑', count: 74 },
  { id: 'c6', name: '动画', count: 52 },
  { id: 'c7', name: '旅行', count: 45 },
  { id: 'c8', name: '科幻', count: 36 },
];

export const faqs: { id: string; q: string; a: string }[] = [
  {
    id: 'f1',
    q: '这里整理的站点都能直接播放吗？',
    a: '页面会标注每个站点当前的状态。标注「在线」的站点可以直接打开播放，标注「线路维护」的站点会稍后恢复，通常几十分钟内即可重新使用。',
  },
  {
    id: 'f2',
    q: '资源和榜单多久更新一次？',
    a: '热度榜与快讯流每日更新一次，深夜片单每周重新整理，站点在线状态每 30 分钟巡检一次，保证你看到的入口都是当前可用的。',
  },
  {
    id: 'f3',
    q: '为什么有时候打开会比较慢？',
    a: '晚间高峰时段线路压力较大。多数站点都提供多条线路，可以在播放页面切换线路 1/2/3，通常几秒内就能恢复流畅。',
  },
  {
    id: 'f4',
    q: '需要注册账号或下载软件吗？',
    a: '不需要。本站只做导航整理，点开即看，无需注册、无需下载任何客户端，也不收集你的个人信息。',
  },
];